import { render, staticRenderFns } from "./subproperty-select.vue?vue&type=template&id=07f6b87b&"
import script from "./subproperty-select.vue?vue&type=script&lang=js&"
export * from "./subproperty-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports